export function requestNotificationPermission() {
  if ("Notification" in window && Notification.permission === "default") {
    Notification.requestPermission().catch(() => {})
  }
}

export function showBrowserNotification(sender, text) {
  if (!("Notification" in window) || Notification.permission !== "granted") return
  if (!document.hidden) return
  const body = text?.slice(0, 100) || "[media]"
  try {
    const n = new Notification(sender, { body, icon: "/favicon.ico", tag: "chat-" + sender })
    n.onclick = () => { window.focus(); n.close() }
  } catch {}
}

export function playMentionSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)()
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)
    osc.type = "sine"
    osc.frequency.value = 880
    gain.gain.setValueAtTime(0.12, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.25)
    osc.start(ctx.currentTime)
    osc.stop(ctx.currentTime + 0.25)
    setTimeout(() => { try { ctx.close() } catch {} }, 600)
  } catch {}
}
